// extracted by mini-css-extract-plugin
export default {"Advertise":"Advertise_Advertise__9-8se","Image":"Advertise_Image__ST8nb"};